import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { html, nothing } from 'lit';

export const AdminLogin = stateful(() => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    if (!password) {
      setError('Bitte Passwort eingeben.');
      return;
    }
    setLoading(true);
    try {
      const resp = await fetch('/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const data = await resp.json();
      if (!data.ok) {
        setError(data.error ?? 'Login fehlgeschlagen.');
      } else {
        window.location.href = '/admin';
      }
    } catch {
      setError('Login fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') void handleLogin();
  };

  return html`
    <div class="ndi-gradient flex min-h-screen items-center justify-center">
      <div class="card bg-base-100 ndi-auth-card w-full max-w-sm shadow-xl">
        <div class="card-body">
          <div class="flex flex-col items-center mb-2">
            <span class="ndi-logo-text text-4xl">NDI</span>
            <span class="text-xs font-medium text-base-content/50 mt-1 tracking-widest uppercase">Admin Dashboard</span>
          </div>
          <h2 class="card-title mb-2 justify-center text-lg font-semibold">Admin Login</h2>

          ${error ? html`<div class="alert alert-error text-sm">${error}</div>` : nothing}

          <div class="form-control">
            <label class="label"><span class="label-text">Admin Passwort</span></label>
            <input
              type="password"
              class="input input-bordered w-full"
              placeholder="Passwort"
              .value=${password}
              @input=${(e: InputEvent) => setPassword((e.target as HTMLInputElement).value)}
              @keydown=${handleKeydown}
            />
          </div>

          <button
            class="btn btn-primary mt-4 w-full ${loading ? 'loading' : ''}"
            @click=${handleLogin}
            ?disabled=${loading}
          >
            ${loading ? 'Wird angemeldet...' : 'Anmelden'}
          </button>
        </div>
      </div>
    </div>
  `;
});
